<template>
  <v-app>
    <v-container>
      <v-card>
        <v-card-title class="text-h6 bg-blue-grey-lighten-4">
          {{ isEntryMode ? "Add Export Document" : "Update Export Document" }}
        </v-card-title>

        <v-divider />

        <v-card-text>
          <v-form @submit.prevent="submit" ref="ExportDocumentForm">
            <v-row>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="lc_document_type_id"
                  :items="documentTypeOptions"
                  item-title="name"
                  item-value="id"
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  clearable
                  :error-messages="errors.lc_document_type_id"
                >
                  <template #label>
                    Document Type <span class="text-red-accent-4">*</span>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="lc_id"
                  :items="lcOptions"
                  :item-title="item => `${item.lc_no || ''}  ${item.code || ''}`"
                  item-value="id"
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  clearable
                  :error-messages="errors.lc_id"
                >
                  <template #label>
                    Select LC <span class="text-red-accent-4">*</span>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="shipment_id"
                  :items="[]"
                  item-title="name"
                  item-value="id"
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  clearable
                  :error-messages="errors.shipment_id"
                >
                  <template #label>
                    Shipment <span class="text-red-accent-4"></span>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">

                <v-autocomplete
                  v-model="amendment_id"
                  :items="[]"
                  item-title="name"
                  item-value="id"
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  clearable
                  :error-messages="errors.amendment_id"
                >
                  <template #label>
                    Amendment <span class="text-red-accent-4"></span>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <v-date-input
                  input-format="dd/mm/yyyy"
                  v-model="document_date"
                  density="compact"
                  prepend-icon=""
                  prepend-inner-icon="mdi-calendar"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  label="Document Date"
                  clearable
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="document_no"
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  label="Document No"
                  clearable
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-file-input
                  v-model="file"
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  show-size
                  :label="isEntryMode ? 'File *' : 'File (leave empty to keep existing)'"
                />
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="remarks"
                  density="compact"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  label="Remarks"
                  auto-grow
                  rows="2"
                  clearable
                />
              </v-col>

              <v-col cols="12">
                <v-checkbox
                  v-model="status"
                  label="Active"
                  density="compact"
                  hide-details
                  color="primary"
                  true-value="1"
                  false-value="0"
                />
              </v-col>
            </v-row>

            <v-divider />

            <v-card-actions>
              <v-layout class="justify-end">
                <v-btn
                  class="bg-red"
                  variant="flat"
                  type="button"
                  @click="$router.back()"
                >
                  Close
                </v-btn>
                <v-btn
                  class="bg-brand w-15 ms-2"
                  variant="flat"
                  type="submit"
                >
                  {{ isEntryMode ? "Save" : "Update" }}
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  name: "LcExportDocument",
  data() {
    return {
      id: this.$route.params.id || null,
      lc_document_type_id: "",
      lc_id: "",
      shipment_id: "",
      amendment_id: "",
      document_date: "",
      document_no: "",
      file: null,
      remarks: "",
      status: "1",
      errors: {},
    };
  },
  computed: {
    isEntryMode() {
      return !this.id;
    },
    documentTypeOptions() {
      return this.$store.getters.getLcDocumentTypeList || [];
    },
    lcOptions() {
      return this.$store.getters.getLcExportLcMasterList || [];
    },
  },
  created() {
    if (!this.documentTypeOptions.length) {
      this.$store.dispatch("getLcDocumentTypeList");
    }

    if (!this.lcOptions.length) {
      this.$store.dispatch("getLcExportLcMasterList");
    }

    if (this.id) {
      this.$store
        .dispatch("getLcExportDocumentById", this.id)
        .then((res) => {
          const d = res.data.data;
          if (!d) return;
          this.lc_document_type_id = d.lc_document_type_id;
          this.lc_id = d.export_lc_id;
          this.shipment_id = d.import_shipment_id;
          this.amendment_id = d.export_amendment_id;
          this.document_date = d.document_date;
          this.document_no = d.document_no;
          this.remarks = d.remarks;
          this.status = String(d.status);
        });
    }
  },
  methods: {
    async submit() {
      this.errors = {};

      if (!this.lc_document_type_id) {
        this.errors.lc_document_type_id = ["Document Type is required"];
        return;
      }
      if (!this.lc_id) {
        this.errors.lc_id = ["LC is required"];
        return;
      }
      if (this.isEntryMode && !this.file) {
        toast.error("File is required");
        return;
      }

      const payload = {
        id: this.id || null,
        lc_document_type_id: this.lc_document_type_id,
        lc_id: this.lc_id,
        shipment_id: this.shipment_id || null,
        amendment_id: this.amendment_id || null,
        document_date: formattedDate(this.document_date),
        document_no: this.document_no || null,
        remarks: this.remarks || null,
        status: this.status,
      };

      if (this.file) {
        payload.file = this.file;
      }

      try {
        const res = await this.$store.dispatch("saveUpdateLcExportDocument",payload);
        toast.success(res.data.message || "Saved successfully");
        this.$router.push({ name: "export-document-records" });
      } catch (e) {
        toast.error(
          e.response?.data?.message || "Failed to save export document"
        );
      }
    },
  },
};
</script>

<style scoped>
.bg-brand {
  background-color: #1976d2;
  color: white;
}
</style>

